import { render, staticRenderFns } from "./single-content.vue?vue&type=template&id=4e2ed01f"
import script from "./single-content.vue?vue&type=script&lang=js"
export * from "./single-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports